import React from 'react';
import { noiseOptions } from '../data/kit';
export function ProblemSection() {
  return <section className="w-full bg-surface py-20 lg:py-28" aria-labelledby="problema" data-id="element-294" data-mp="2lstkdivokeg4">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-2 lg:gap-16" data-id="element-295" data-mp="30gxtpw8ufdm8">
        <div data-id="element-296" data-mp="30j0w7fr6mz7u">
          <h2 id="problema" className="font-display text-3xl font-black leading-tight tracking-tight sm:text-4xl lg:text-5xl" data-id="element-297" data-mp="2vqr907hgcd99">
            ¿Querés ganar plata online pero no sabés por dónde empezar?
          </h2>
          <p className="mt-6 text-lg text-muted" data-id="element-298" data-mp="35gtzo113pf4f">Probablemente ya viste cientos de opciones.</p>
          <p className="mt-8 text-lg text-ink" data-id="element-299" data-mp="3jglicf2kbjor">Y cuanto más investigás…</p>
          <p className="mt-2 font-display text-2xl font-black text-danger sm:text-3xl" data-id="element-300" data-mp="3egz6oa2dubi2">Más difícil parece elegir.</p>
        </div>

        <ul className="flex flex-wrap content-center gap-2.5" aria-label="Opciones que probablemente ya viste" data-id="element-301" data-mp="1p19755zi4gly">
          {noiseOptions.map((option, i) => <li key={option} className={`rounded-full border border-line bg-paper px-4 py-2 font-medium text-muted ${i % 3 === 0 ? 'text-lg' : i % 3 === 1 ? 'text-base' : 'text-xl'}`} style={{
          transform: `rotate(${i * 7 % 5 - 2}deg)`
        }} data-id="element-302" data-mp="1k5an1ul7hkrc" data-mpi={i}>
              {option}.
            </li>)}
        </ul>
      </div>

      <div className="mx-auto mt-20 max-w-6xl px-5" data-id="element-303" data-mp="123ld6jpgyr8k">
        <div className="rounded-3xl bg-ink px-6 py-12 text-white sm:px-12 lg:px-16 lg:py-16" data-id="element-304" data-mp="122thl8vvgtia">
          <div className="grid gap-10 lg:grid-cols-[1.2fr_1fr] lg:items-end" data-id="element-305" data-mp="171ei79f1df79">
            <div data-id="element-306" data-mp="1c1izv2rokfz2">
              <p className="text-lg text-white/70" data-id="element-307" data-mp="1c33usthwq0xg">El problema no es que falten oportunidades.</p>
              <p className="mt-1 font-display text-3xl font-black sm:text-4xl" data-id="element-308" data-mp="1g22wm58cdhko">El problema es que sobran.</p>
              <p className="mt-8 text-lg text-white/80" data-id="element-309" data-mp="3duqdm7rnapiu">
                Por eso creamos algo diferente. No vas a encontrar una lista con{' '}
                <span className="text-white/50 line-through decoration-danger decoration-2" data-id="element-310" data-mp="p0921ualpeg4">
                  “137 maneras de ganar dinero por Internet”
                </span>
                .
              </p>
            </div>
            <div className="border-t border-white/15 pt-8 lg:border-l lg:border-t-0 lg:pl-10 lg:pt-0" data-id="element-311" data-mp="y1762cl1hlyp">
              <p className="text-white/70" data-id="element-312" data-mp="tyaj69ogv3oy">Seleccionamos solamente:</p>
              <p className="mt-1 font-display text-6xl font-black text-cta" data-id="element-313" data-mp="17yv1z5udszig">3 modelos.</p>
              <p className="mt-4 text-white/80" data-id="element-314" data-mp="1301ovej0bait">
                Tres caminos concretos. Tres formas completamente diferentes de generar ingresos. Y una guía paso a
                paso para cada uno.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}